const consts = {
  Main: process.env.REACT_APP_ENV || "Development",
  MainUrl: process.env.REACT_APP_MAIN_URL || "http://localhost:3000",
  BackendUrl: process.env.REACT_APP_BACKEND_URL || "http://localhost:3005/ez5050Api",
  socketUrl: process.env.REACT_APP_SOCKET_URL || "http://localhost:3005",
  type: process.env.REACT_APP_ENV || "Development",
  route: "ez5050Admin",
  PrimaryColor: "#FC4420",
};

export default consts;
